import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, List, ListItem, ListItemText } from '@mui/material';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase/firebaseConfig';

const allowedCountries = ['Germany', 'Switzerland', 'Poland', 'France', 'United Kingdom'];

const paymentMethods = {
  Germany: { name: 'PayPal', details: 'Send payment to paypal@germany.com' },
  Switzerland: { 
    name: 'Credit Card', 
    details: 'Bank: Swiss Bank\nIBAN: CH93 1234 5678 9012 3456 7\nSWIFT: SWISS123'
  },
  Poland: { name: 'BLIK', details: 'Use BLIK code: 123456 at your banking app' },
  France: { 
    name: 'SEPA Bank Transfer', 
    details: 'Bank: BNP Paribas\nIBAN: FR76 1234 5678 9012 3456 7890 123\nBIC: BNPFRA12'
  },
  'United Kingdom': { 
    name: 'Apple Pay', 
    details: 'Pay via Apple Pay linked to your device'
  },
};

const MakePaymentDialog = ({ open, onClose, buyerId, handleReservePayment }) => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (buyerId && open) {
      fetchAssessments();
    }
  }, [buyerId, open]);

  const fetchAssessments = async () => {
    try {
      setLoading(true);
      console.log('Fetching assessments for buyerId:', buyerId);

      const assessmentsRef = collection(db, 'assessment_requests');
      const q = query(assessmentsRef, where('buyer_id', '==', buyerId));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        console.log('No documents found for this buyerId');
      } else {
        console.log('Documents found:', querySnapshot.size);
      }

      const fetchedAssessments = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log('Fetched assessments:', fetchedAssessments);
      setAssessments(fetchedAssessments);
    } catch (err) {
      console.error('Error fetching assessments:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePayment = (assessment) => {
    const shippingCountry = assessment.shippingAddress?.country || 'N/A';
    const paymentMethod = paymentMethods[shippingCountry];

    if (!paymentMethod) {
      alert(`No payment method available for ${shippingCountry}`);
    } else {
      alert(`Opening ${paymentMethod.name} for ${shippingCountry}\n\n${paymentMethod.details}`);
      handleReservePayment(assessment);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Pending Payments</DialogTitle>
      <DialogContent>
        {loading ? (
          <p>Loading...</p>
        ) : assessments.length === 0 ? (
          <p>No assessments found.</p>
        ) : (
          <List>
            {assessments.map((assessment) => {
              const totalPrice = assessment.costBreakdown?.totalPrice || 'N/A';
              const shippingCountry = assessment.shippingAddress?.country || 'N/A';
              const paymentMethod = paymentMethods[shippingCountry];

              return (
                <ListItem key={assessment.id} divider>
                  <ListItemText
                    primary={`Assessment #${assessment.id}`}
                    secondary={`Total Price: ${totalPrice} | Shipping to: ${shippingCountry} | Payment: ${paymentMethod?.name || 'Unavailable'}`}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!paymentMethod}
                    onClick={() => handlePayment(assessment)}
                  >
                    Pay Now
                  </Button>
                </ListItem>
              );
            })}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MakePaymentDialog;
